// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3GPPH","upload":"Small_upload__16qWD","imageWrap":"Small_imageWrap__-1lrb","removeBtn":"Small_removeBtn__pjnr6"};